import { render } from "./CategoryDetailView.vue?vue&type=template&id=72a8d3a7"
import script from "./CategoryDetailView.vue?vue&type=script&lang=js"
export * from "./CategoryDetailView.vue?vue&type=script&lang=js"

import "./CategoryDetailView.vue?vue&type=style&index=0&id=72a8d3a7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__